<template>
	<div class="view-review">
		<Modal
			:show="showAddReviews"
			content_class="col-12 col-md-8 col-lg-6 col-xl-5 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Add Review</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showAddReviews', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="card">
									<Form
										classBinding="row"
										:ref="Product.forms.submitReview.name"
										:forms="
											Product.forms.submitReview.forms
										"
										:form_data="
											Product.forms.submitReview.data
										"
									/>

									<div class="buttons">
										<div class="row">
											<div class="col-12">
												<div
													class="btn btn-long btn-yellow"
													@click="
														submitReview({
															ref: $refs[
																Product.forms
																	.submitReview
																	.name
															],
														})
													"
													:disabled="loading"
												>
													Submit Review
													<div
														class="lds-ring"
														v-show="loading"
													>
														<div></div>
														<div></div>
														<div></div>
														<div></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
	},
	computed: {
		...mapGetters(['loading', 'showAddReviews', 'Product']),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['submitReview']),
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-review {
}
</style>
